import { Fab, Typography } from "@mui/material";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import { Stack } from "@mui/system";

type Props = {
  disabledButton: boolean;
  handleClick: any;
};

export default function FloatingButton({ handleClick, disabledButton }: Props) {
  return (
    <Stack
      spacing={2}
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 1300,
        alignItems: "flex-end",
      }}
    >
      <Fab
        variant="extended"
        color="secondary"
        size="small"
        disabled={disabledButton}
        onClick={handleClick}
        sx={{
          width: 163,
          backgroundColor: "#7B1FA2",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#7B1FA2",
          },
          padding: "20px 16px",
          borderRadius: "100px",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Typography fontSize={15} fontWeight={500}>
            {"Take Action"}
          </Typography>
          <AutoFixHighOutlinedIcon />
        </Stack>
      </Fab>
    </Stack>
  );
}
